import React, { useContext, useEffect, useState } from 'react'
import AccessContext from '../../context/AccessContext/AccessContext';
import AccessVehiclesContext from '../../context/AccessVehiclesContext/AccessVehiclesContext';
import EmployeeInfoCard from '../Employee/EmployeeInfoCard'
import SelectDateAndTime from '../SelectDateAndTime/SelectDateAndTime'
import ButtonBlackReturn from '../Buttons/ButtonBlackReturn';
import { ButtonBlue } from '../Buttons/ButtonBlue';
import { getTenantInfoByKey, getUserBuilding, getUserOpening, isoToDate, replaceExpecialCharacters } from '../../helpers/helpers';
import { Spinner } from 'reactstrap';
import VehicleOperableCard from '../Vehicle/VehicleOperableCard';
import ItemWithStatusOperable from '../ItemSelectable/ItemWithStatusOperable';
import vehicleImg from '../../assets/vehicle-select-icon.svg';
import visitReasonImg from '../../assets/icons/visit-reaseon.svg';
import accessAreaImg from '../../assets/icons/acess-area-icon.svg';
import accessPersonToVisitImg from '../../assets/icons/access-person-to-visit.svg';
import { t } from 'i18next';
import VehicleVisit from '../Vehicle/VehicleVisit';
import VisitInfoCard from '../Visit/VisitInfoCard';
import useGetDateAndHour from '../../customHooks/useGetDateAndHour';
import AccessAreaContext from '../../context/AccessAreaContext/AccessAreaContext';
import { useNavigate } from 'react-router-dom';
import AccessPersonToVisitContext from '../../context/AccessPersonToVisitContext/AccessPersonToVisitContext';
import AccessEquipmentContext from '../../context/AccessEquipment/AccessEquipmentContext';
import { EquipmetsOrTool } from '../EquipmetsOrTool/EquipmetsOrTool';

const Detail = () => {

    const { accessState, confirmAccess, setStep, confirmExit, clean } = useContext(AccessContext);
    const { employee, accessWithCar, accessWithEquipmentOrTools, confirmingMovement, type, visit } = accessState;

    const { accessVehiclesState, setAccessVehiclesSelected, setVisitVehiclesSelected, cleanAccessVehiclesState } = useContext(AccessVehiclesContext);
    const { accessVehiclesSelected } = accessVehiclesState;

    const { accessAreaState } = useContext(AccessAreaContext);
    const { accessAreasSelected } = accessAreaState;

    const { accessPersonToVisitState } = useContext(AccessPersonToVisitContext);
    const { accessPersonsToVisitSelected, accessPersonsToVisit } = accessPersonToVisitState;

    const { accessEquipmentState, setAccessEquipmentsSelected, setAccessEquipment } = useContext(AccessEquipmentContext);
    const { accessEquipmentsSelected } = accessEquipmentState;

    const haveAccessBuildings = getUserBuilding().buildingDescription !== t('NO_BUILDING');;

    const havePersonsToVisit = getTenantInfoByKey('has_people_to_visit') && accessPersonsToVisit.length > 0;

    const haveEnabledEquipmentsType = getTenantInfoByKey('has_enabled_equipments_type');

    const navigate = useNavigate();

    const isExit = ['EXIT_VISIT', 'EXIT'].some(typeOption => typeOption === type);

    const isVisit = ['ACCESS_VISIT', 'EXIT_VISIT'].some(typeOption => typeOption === type);

    const { systemDate, isFetchingSystemDate, error, errorMessage } = useGetDateAndHour();

    const [date, setDate] = useState({
        accessDate: '',
        accessHour: '',
        exitDate: '',
        exitHour: '',
    });

    const [observation, setObservation] = useState('');

    const disabled = () => {
        if (isExit) {

            const exitDatesExist = !!date.exitDate.trim() && !!date.exitHour;

            const exitDateAreMoreThanAccessDate = new Date(`${date.exitDate}T${date.exitHour}:00`).getTime() <= new Date(`${date.accessDate}T${date.accessHour}:00`).getTime()

            const exitDateIsMoreThanCurrentDate = new Date(`${date.exitDate}T${date.exitHour}:00`).getTime() > new Date(`${systemDate.slice(0, 10)}T${systemDate.slice(11, 16)}:00`).getTime()

            return !exitDatesExist || exitDateAreMoreThanAccessDate || exitDateIsMoreThanCurrentDate
        } else {

            const acessDatesExist = !!date.accessDate.trim() && !!date.accessHour;

            const accessDateAreMoreThanCurrentDate = new Date(`${date.accessDate}T${date.accessHour}:00`).getTime() > new Date(`${systemDate.slice(0, 10)}T${systemDate.slice(11, 16)}:00`).getTime()

            return !acessDatesExist || accessDateAreMoreThanCurrentDate
        }
    }

    const handleConfirm = () => {

        if (disabled()) return

        const opening_code = getUserOpening().codigo;

        const building_id = String(getUserBuilding().buildingId);

        const area_id = String(accessAreasSelected.area_id);

        const people_to_visit_ids = accessPersonsToVisitSelected.map(accessPersonToVisitSelected => accessPersonToVisitSelected.peopleToVisitId);

        const equipments_type = accessEquipmentsSelected.map(accessEquipmentSelected => ({
            id: accessEquipmentSelected.id.value,
            details: accessEquipmentSelected.details
        }))

        const movementDateValue = isExit ?
            {
                egress_date: `${date.exitDate.split('-').join('')}${date.exitHour.split(':').join('')}00`,
            }
            :
            {
                entry_date: `${date.accessDate.split('-').join('')}${date.accessHour.split(':').join('')}00`,
            };

        const visitors = isExit ? [visit?.document] : [visit];

        const exitVisitVehicles = accessVehiclesSelected.map(vehicle => vehicle.plate_number);

        const visitor_vehicles = isExit ? exitVisitVehicles : accessVehiclesSelected;

        const employees = [employee?.id];

        const vehicles = accessVehiclesSelected.map(vehicle => vehicle.vehicle_id);

        const resourceValues = isVisit ?
            {
                visitors,
                visitor_vehicles
            }
            :
            {
                employees,
                vehicles,
            }

        const movementValues = {
            observation,
            opening_code,
            building_id,
            area_id,
            people_to_visit_ids,
            equipments_type,
            ...movementDateValue,
            ...resourceValues
        }

        if (isExit) {
            confirmExit(movementValues)
        } else {
            confirmAccess(movementValues)
        }
    }

    const handleGetBack = () => {

        if (isExit && isVisit) {
            navigate('/dashboard');
            clean();
            cleanAccessVehiclesState();
            return
        }

        if (isExit === false) {
            if (havePersonsToVisit) {
                setStep('SELECT_PERSON_TO_VISIT')
                return
            }

            if (haveAccessBuildings) {
                setStep('SELECT_AREA')
                return
            }

            if (haveEnabledEquipmentsType && accessWithEquipmentOrTools) {
                setStep('SELECT_EQUIPMENT_OR_TOOLS')
                return
            }
        }

        accessWithCar ? setStep('VEHICLES_SELECTABLE') : setStep('ACCESS_WITH')

        return
    }

    const removeEmployeeVehicle = (id) => {
        setAccessVehiclesSelected(accessVehiclesSelected.filter(accessVehicleSelected => accessVehicleSelected.vehicle_id !== id))
    }

    const canEditAccessVehicle = () => {
        if (isVisit) {
            return isExit === false
        }

        return employee.is_driver === true
    }

    const editEmployeeVehicle = () => {
        const nextStep = isVisit ? 'VISIT_VEHICLE_FORM' : 'VEHICLES_SELECTABLE'
        setStep(nextStep);
    }

    const deleteVisitVehicle = (index) => {
        if (index < 0 || index >= accessVehiclesSelected.length) {
            setAccessVehiclesSelected(accessVehiclesSelected);
        } else {
            setAccessVehiclesSelected(accessVehiclesSelected.slice(0, index).concat(accessVehiclesSelected.slice(index + 1)));
        }
    }

    const editVehicleVisit = (vehicle, index) => {
        setAccessVehiclesSelected(accessVehiclesSelected.slice(0, index).concat(accessVehiclesSelected.slice(index + 1)));
        setVisitVehiclesSelected(vehicle);
        setStep('VISIT_VEHICLE_FORM')
    }

    const deleteEquipmet = (details) => {
        setAccessEquipmentsSelected(accessEquipmentsSelected.filter(accessEquipmentSelected => accessEquipmentSelected.details !== details));
    }

    const editEquipmet = (details) => {
        const equipmentCreatedToEdit = accessEquipmentsSelected.find(accessEquipmentSelected => accessEquipmentSelected.details === details);
        setAccessEquipment(equipmentCreatedToEdit);
        deleteEquipmet(details);
        setStep('SELECT_EQUIPMENT_OR_TOOLS');
    }

    useEffect(() => {
        const handleSetDates = () => {
            if (systemDate !== null) {
                if (isExit) {
                    const accessDate = isVisit ? isoToDate(visit.entry_date, 'YYYYMMDD', '-') : isoToDate(employee.entry_date, 'YYYYMMDD', '-');
                    setDate({
                        accessDate: accessDate.slice(0, 10),
                        accessHour: accessDate.slice(11, 16),
                        exitDate: systemDate.slice(0, 10),
                        exitHour: systemDate.slice(11, 16),
                    })
                    return
                }
                if (!isExit) {
                    setDate({
                        accessDate: systemDate.slice(0, 10),
                        accessHour: systemDate.slice(11, 16),
                        exitDate: "",
                        exitHour: "",
                    })
                    return
                }
            }
        };
        handleSetDates();
        // eslint-disable-next-line
    }, [systemDate])

    return (
        <div className='d-flex flex-column justify-content-between h-100'>

            <div>
                <h5 className='d-sm-block d-none fw-bold'>
                    {isExit ? t('EXIT_DETAIL') : t('ENTRY_DETAIL')}
                </h5>
                <div
                    className="d-flex flex-column gap-3 no-show-scroll"
                    style={{ maxHeight: '600px', overflowX: 'auto' }}
                >

                    <SelectDateAndTime
                        type={type}
                        date={date}
                        setDate={setDate}
                        isFetchingDates={isFetchingSystemDate}
                        error={error}
                        errorMessage={errorMessage}
                    />

                    {employee && (
                        <EmployeeInfoCard
                            employee={employee}
                        />
                    )}

                    {visit && (
                        <>
                            <VisitInfoCard
                                visit={visit}
                                onClickEdit={!isExit && (() => setStep('VISIT_FORM'))}
                            />
                            <ItemWithStatusOperable
                                onCLickEdit={!isExit && (() => setStep('VISIT_FORM'))}
                            >
                                <div className='d-flex align-items-center gap-2'>
                                    <img
                                        style={{ width: '63px', height: '63px' }}
                                        src={visitReasonImg}
                                        alt=""
                                    />
                                    <div>
                                        <p className='m-0 vehiclePatent-card'>
                                            {t('VISIT_REASON')}
                                        </p>
                                        <p className='m-0 vehicleName-card'>
                                            {visit.reason ? visit.reason : '-'}
                                        </p>
                                    </div>
                                </div>
                            </ItemWithStatusOperable>
                        </>
                    )}

                    {haveEnabledEquipmentsType && (
                        accessEquipmentsSelected.map(accessEquipmentSelected =>
                            <EquipmetsOrTool
                                key={accessEquipmentSelected.details}
                                type={accessEquipmentSelected.id.label}
                                details={accessEquipmentSelected.details}
                                deleteFn={!isExit && (() => deleteEquipmet(accessEquipmentSelected.details))}
                                editFn={!isExit && (() => editEquipmet(accessEquipmentSelected.details))}
                            />

                        )
                    )}

                    {haveAccessBuildings && (
                        <ItemWithStatusOperable
                            onCLickEdit={!isExit && (() => setStep('SELECT_AREA'))}
                        >
                            <div className='d-flex align-items-center gap-2'>
                                <img
                                    style={{ width: '63px', height: '63px' }}
                                    src={accessAreaImg}
                                    alt=""
                                />
                                <div>
                                    <p
                                        className={`${(accessAreasSelected.description !== t('FREE_ACCESS_AREA')) ? 'm-0' : ''} vehicleName-card`}
                                    >
                                        {accessAreasSelected.code ? `${accessAreasSelected.code} - ` : ''}{accessAreasSelected.description}
                                    </p>
                                    <p className='m-0 vehiclePatent-card'>
                                        {(accessAreasSelected.description !== t('FREE_ACCESS_AREA')) && (
                                            `${t('ACCESS_ONLY_TO')} ${accessAreasSelected.description}`
                                        )}
                                    </p>
                                </div>
                            </div>
                        </ItemWithStatusOperable>
                    )}

                    {havePersonsToVisit && (
                        accessPersonsToVisitSelected.map((personToVisit) =>
                            <ItemWithStatusOperable
                                key={personToVisit.documentNumber}
                                onCLickEdit={!isExit && (() => setStep('SELECT_PERSON_TO_VISIT'))}
                            >
                                <div className='d-flex align-items-center gap-2'>
                                    <img
                                        style={{ width: '63px', height: '63px' }}
                                        src={accessPersonToVisitImg}
                                        alt=""
                                    />
                                    <div>
                                        <p className='m-0 vehicleName-card'>
                                            {personToVisit.documentNumber} {personToVisit.name} {personToVisit.lastName}
                                        </p>
                                        <p className='m-0 vehiclePatent-card'>
                                            {personToVisit.sector ? personToVisit.sector.sectorName : t('WITHOUT_SECTOR')}
                                        </p>
                                    </div>
                                </div>
                            </ItemWithStatusOperable>
                        )
                    )}

                    {accessVehiclesSelected.map((vehicle, idx) =>
                        isVisit ?
                            <VehicleVisit
                                key={idx}
                                visitVehicle={vehicle}
                                onClickDelete={!isExit && (() => deleteVisitVehicle(idx))}
                                onClickEdit={!isExit && (() => editVehicleVisit(vehicle, idx))}
                            />
                            :
                            <VehicleOperableCard
                                key={idx}
                                vehicle={vehicle}
                                onClickDelete={() => removeEmployeeVehicle(vehicle.vehicle_id)}
                                onCLickEdit={editEmployeeVehicle}
                            />
                    )}

                    {accessVehiclesSelected.length === 0 && (
                        <ItemWithStatusOperable
                            onCLickEdit={canEditAccessVehicle() && (editEmployeeVehicle)}
                        >
                            <div className='d-flex align-items-center gap-2'>
                                <img src={vehicleImg} alt="" />
                                <div>
                                    <p className='m-0 vehicleName-card'>{t('NO_CAR')}</p>
                                    <p className='m-0 vehiclePatent-card'>{isExit ? t('NO_CAR_EXIT') : t('NO_CAR_ACCESS')}</p>
                                </div>
                            </div>
                        </ItemWithStatusOperable>
                    )}

                    <div>
                        <label
                            htmlFor="observations"
                            className="blue-dark-text"
                        >
                            {t('OBSERVATIONS')}
                        </label>
                        <textarea
                            className='form-control'
                            name="observations"
                            cols="30"
                            rows="5"
                            value={observation}
                            placeholder={t('ENTER_OBSERVATIONS')}
                            maxLength={255}
                            onChange={(e) => setObservation(replaceExpecialCharacters(e.target.value))}
                        >
                        </textarea>
                    </div>

                </div>
            </div>

            {
                confirmingMovement ?
                    <div className="d-flex justify-content-center mt-4 mb-4">
                        <Spinner />
                    </div>
                    :
                    <div className='d-flex justify-content-between align-items-center mt-4 mb-4'>
                        <div className="w-75">
                            <ButtonBlackReturn title={t('GET_BACK')} onClick={handleGetBack} />
                        </div>
                        <div className="w-50">
                            <ButtonBlue className='w-100' onClick={handleConfirm} disabled={disabled()}>
                                {t('CONFIRM')}
                            </ButtonBlue>
                        </div>
                    </div>
            }
        </div>
    )
}

export default Detail